function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { useState } from "react";
import FontAwesome from "react-fontawesome";

var PhotoItem = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PhotoItem, _React$Component);

  function PhotoItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PhotoItem.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      onClick: this.props.onDeleteButtonClick
    }, /*#__PURE__*/React.createElement(FontAwesome, {
      style: {
        color: "white",
        fontSize: "20px",
        position: "absolute",
        right: "5px",
        top: "5px"
      },
      className: "d-print-none",
      name: "window-close"
    })), /*#__PURE__*/React.createElement("img", this.props.imageProps), ";");
  };

  return PhotoItem;
}(React.Component);

export default PhotoItem;